// import React from "react";
// import lettemicael from "../images/LettemicaelMezghebeBanks.jpg";
import YoutubeEmbed from "./YoutubeEmbed";
import { NavLink, Link } from "react-router-dom";
import "./temporary.css";

const Temporary = () => {
  return (
    <div>
      <div className="temporary-right temp-responsive">
        <div className="gallery-item temp-responsive">
          <YoutubeEmbed
            embedId="lDBzo9-KfQw"
            inputWidth="420"
            inputHeight="600"
            caption="Tigrayan kids advertisement to support Rediet fundraising, Virgina, USA"
          />
        </div>
        <div className="donation-call" >
          <p>
            <NavLink className="donation-link" to="/donate">
              Donate to Rediet today - You will save lives
            </NavLink>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Temporary;
